var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeverage = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.328 3.06a6.732 6.732 0 1 0 0 13.464 6.732 6.732 0 0 0 0-13.465ZM2.203 9.791a8.125 8.125 0 1 1 16.25 0 8.125 8.125 0 0 1-16.25 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.488 8.319c.006-.26.08-.366.13-.416.066-.066.193-.138.429-.175.491-.079 1.155.035 1.704.18l.673.177.355-1.347-.674-.177c-.578-.153-1.482-.336-2.277-.209-.408.065-.853.221-1.2.57-.36.364-.533.856-.533 1.428v.026l.002.026c.05.662.444 1.102.853 1.392.374.265.839.458 1.214.614l.042.018c.423.176.738.312.956.472.191.14.21.225.21.3 0 .291-.085.407-.152.467-.09.082-.259.16-.546.197-.586.072-1.347-.071-1.907-.221l-.673-.18-.36 1.345.673.18c.592.159 1.572.366 2.439.258.439-.055.925-.2 1.308-.546.406-.367.611-.883.611-1.5 0-.673-.376-1.128-.78-1.424-.369-.27-.836-.464-1.212-.621l-.032-.013c-.423-.176-.75-.315-.986-.483-.2-.142-.254-.246-.267-.338Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.328 12.23c.385 0 .696.31.696.696v1.74H9.631v-1.74c0-.385.312-.697.697-.697ZM11.024 4.917v1.74a.696.696 0 1 1-1.393 0v-1.74h1.393Z",
    fill: "#fff"
  })));
};
export default SvgLeverage;